import React, { useState } from "react";
import img1 from "../../Assets/consultorio_1.jpeg";
import img2 from "../../Assets/consultorio_5.jpeg";
import img3 from "../../Assets/consultorio_2.jpeg";
import img4 from "../../Assets/consultorio_6.jpeg";
import "./Consultorio.css";

const officeImages = [img1, img2, img3, img4];

const Consultorio = () => {
  const [current, setCurrent] = useState(0);

  const prev = () =>
    setCurrent((c) => (c - 1 + officeImages.length) % officeImages.length);
  const next = () =>
    setCurrent((c) => (c + 1) % officeImages.length);

  return (
    <section className="consultorioSection" id="consultorio">
      <div className="consultorioInner">

        {/* Carousel — derecha (row-reverse) */}
        <div className="consultorioCarousel">
          <img
            src={officeImages[current]}
            alt={`Consultorio ${current + 1}`}
            className="consultorioImg"
            loading="lazy"
            width="1280"
            height="960"
          />
          <button className="carouselBtn carouselBtnLeft" onClick={prev} aria-label="Anterior">
            &#8249;
          </button>
          <button className="carouselBtn carouselBtnRight" onClick={next} aria-label="Siguiente">
            &#8250;
          </button>
          <div className="carouselDots">
            {officeImages.map((_, i) => (
              <button
                key={i}
                className={`carouselDot${i === current ? " active" : ""}`}
                onClick={() => setCurrent(i)}
                aria-label={`Imagen ${i + 1}`}
              />
            ))}
          </div>
        </div>

        {/* Info — izquierda */}
        <div className="consultorioInfo">
          <p className="consultorioLabel">Nuestro consultorio</p>
          <h2 className="consultorioHeading">Junín 2612<br />Santa Fe</h2>
          <span className="consultorioPhone">+549 342 407-2977</span>
          <p className="consultorioSchedule">
            Lunes a Viernes &middot;{" "}
            <a href="/calendar" className="consultorioCalLink">Ver disponibilidad</a>
          </p>
          <div className="consultorioBtns">
            <a href="/calendar" className="infoBtnPrimary">Agendar consulta</a>
            <a
              href="https://maps.app.goo.gl/HTbFFF9gs6YEn2MV9"
              target="_blank"
              rel="noreferrer"
              className="infoBtnGhost"
            >
              Ver en Google Maps
            </a>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Consultorio;
